import { render, staticRenderFns } from "./ReferenciasForm.vue?vue&type=template&id=41c812f0&"
import script from "./ReferenciasForm.vue?vue&type=script&lang=js&"
export * from "./ReferenciasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports